var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarSimple = function SvgStarSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.372 14.735-3.913 2.058a1 1 0 0 1-1.451-1.055l.747-4.357a1 1 0 0 0-.287-.885L.302 7.41a1 1 0 0 1 .554-1.705l4.375-.636a1 1 0 0 0 .753-.547L7.94.558a1 1 0 0 1 1.794 0l1.956 3.964a1 1 0 0 0 .753.547l4.375.636a1 1 0 0 1 .554 1.705l-3.165 3.086a1 1 0 0 0-.288.885l.747 4.357a1 1 0 0 1-1.45 1.055l-3.914-2.058a1 1 0 0 0-.93 0Z",
    fill: "#003E52"
  })));
};
export default SvgStarSimple;